interface IBuildQuizUrlParams {
  quizId?: string;
  isFromBaseContent?: boolean;
}

export const buildQuizUrl = ({ quizId, isFromBaseContent }: IBuildQuizUrlParams) => {
  const path = quizId ? `/evaluation/tests/${quizId}/edit` : '/evaluation/tests/create';
  const params = new URLSearchParams();
  if (isFromBaseContent) params.set('isFromBaseContent', 'true');

  const query = params.toString();
  return query ? `${path}?${query}` : path;
};
